import React from 'react'
import { Route, Switch, useLocation, useHistory } from 'react-router-dom';
import { ExpandableSidebar, Wrapper,} from 'retro/index';
import AllTds from './AllTds'
import QueuesIcon from '@atlaskit/icon/glyph/queues';


const TOPITEMS = () => {
    const Location = useLocation();
    const HISTORY = useHistory();
    const ITEMS = [{
        title: 'TDS',
        actions: [
          {
            title: 'All Tds',
            icon: <QueuesIcon size='small' />,
            active: Location.pathname === '/app/tds',
            onClick: () => {
              HISTORY.push('/app/tds');
            },
          },
        ],
      }]
    return ITEMS;
};
function index() {
  return (
    <div className='flex h-100h w-100'>
      <ExpandableSidebar items={TOPITEMS()}  />
      <Wrapper>
        <Switch>
          <Route component={AllTds} path='/app/tds' exact />
        </Switch>
      </Wrapper> 
    </div>
  )
}

export default index
